import { Link } from "react-router-dom";
import { Plus, Eye } from "lucide-react";
import { toast } from "sonner";
import { useQuote } from "@/context/QuoteContext";

const ProductCard = ({ product, categoryName, categorySlug }) => {
  const { addItem } = useQuote();

  const handleAdd = () => {
    addItem(product, categoryName);
    toast.success(`${product.name} added to your quote`);
  };

  const detailHref = product.slug && categorySlug ? `/products/${categorySlug}/${product.slug}` : null;

  return (
    <article
      data-testid={`product-card-${product.id}`}
      className="group bg-white border border-[#E5E5E5] hover:border-[#D4AF37]/60 hover:shadow-[0_12px_40px_rgb(0,0,0,0.06)] transition-all duration-500 flex flex-col"
    >
      {detailHref ? (
        <Link to={detailHref} className="block aspect-square w-full overflow-hidden bg-[#FAF9F6] flex items-center justify-center">
          <img
            src={product.image}
            alt={product.name}
            loading="lazy"
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
          />
        </Link>
      ) : (
        <div className="aspect-square w-full overflow-hidden bg-[#FAF9F6] flex items-center justify-center">
          <img
            src={product.image}
            alt={product.name}
            loading="lazy"
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
          />
        </div>
      )}
      <div className="p-6 flex flex-col flex-1">
        {detailHref ? (
          <Link to={detailHref} data-testid={`product-name-${product.id}`} className="font-serif-display text-lg leading-snug mb-2 hover:text-[#D4AF37] transition-colors">
            {product.name}
          </Link>
        ) : (
          <h3 data-testid={`product-name-${product.id}`} className="font-serif-display text-lg leading-snug mb-2">{product.name}</h3>
        )}
        <p className="text-xs text-[#4A4A4A] leading-relaxed min-h-[2.5rem] flex-1">{product.spec}</p>
        <div className="mt-5 grid grid-cols-1 gap-2">
          {detailHref && (
            <Link
              to={detailHref}
              data-testid={`view-details-${product.id}`}
              className="w-full border border-[#1A1A1A] hover:bg-[#1A1A1A] hover:text-white text-[#1A1A1A] py-3 text-xs uppercase tracking-[0.2em] transition-colors flex items-center justify-center gap-2"
            >
              <Eye className="w-3.5 h-3.5" />
              View Details
            </Link>
          )}
          <button
            data-testid={`add-to-quote-${product.id}`}
            onClick={handleAdd}
            className="w-full bg-[#1A1A1A] hover:bg-[#D4AF37] text-white py-3 text-xs uppercase tracking-[0.2em] transition-colors flex items-center justify-center gap-2"
          >
            <Plus className="w-3.5 h-3.5" />
            Add to Quote
          </button>
        </div>
      </div>
    </article>
  );
};

export default ProductCard;
